import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy ".html" address: permanent redirect to /impressum.
export const Route = createFileRoute("/impressum.html")({
  loader: () => {
    throw redirect({ to: "/impressum", statusCode: 301 });
  },
});
